export default __webpack_public_path__ + "static/media/Kale-Closeup-400px.jpg.1539f73a.webp";